module.exports = __webpack_public_path__ + "img/grabar.52613158.png";